export default class BucketError extends Error {
  name = 'BucketError'
  isUrlExpired = false
  status = 0
  statusText = ''

  constructor(presignedUrl, response) {
    super('An error while fetching data from your bucket', { cause: response.statusText })
    this.status = response.status
    this.statusText = response.statusText
    if (response.status === 403) {
      this.isUrlExpired = this.getIsUrlExpired(presignedUrl)
    }
  }

  getIsUrlExpired(presignedUrl) {
    const urlSearchParams = new URLSearchParams(presignedUrl)
    // Google
    if (urlSearchParams.has('Expires')) {
      return Number.parseInt(urlSearchParams.get('Expires')) < Math.floor(Date.now() / 1000)
    }
    // Azure
    if (urlSearchParams.has('se')) {
      return new Date(urlSearchParams.get('se')).getTime() < Date.now()
    }
    // S3
    if (urlSearchParams.has('X-Amz-Expires')) {
      const dateStr = urlSearchParams.get('X-Amz-Date').replace(/(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z/, '$1-$2-$3T$4:$5:$6Z')
      return Number.parseInt(urlSearchParams.get('X-Amz-Expires')) * 1000 < Date.now() - new Date(dateStr).getTime()
    }
    return false
  }
}
